/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { StoreTabColorDecisionMaker } from "../../../utils/chipColorDecisionMaker";
import ProcesingOrdersDataTable from "./ProcessingOrdersDataTable";
import {  useSelector } from "react-redux";
import { orderSelector } from "../../../../../redux/slices/orderSlice";
import { Download } from "@mui/icons-material";


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function OrderProcessingTabs({ processId }) {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const { batchProcessOrders } = useSelector(orderSelector);
  let activeOrders = [];
  let fulfilledOrders = [];
  let failedOrders = [];

  if (batchProcessOrders?.batch_processes?.length > 0 && !processId) {
    activeOrders =
      // batchProcessOrders?.batch_processes[0]?.status === "processing" &&
      batchProcessOrders?.batch_processes[0]?.orders?.filter(
        (order) => order?.status?.toString() === "processing"
      );
    fulfilledOrders = batchProcessOrders?.batch_processes[0]?.orders?.filter(
      (order) => order.status === "Shipped"
    );
    failedOrders = batchProcessOrders?.batch_processes[0]?.orders?.filter(
      // eslint-disable-next-line array-callback-return
      (order) => {
        if (!order?.status || order?.status !== "Shipped") {
          const normalizeObj = {
            ...order,
            tracking_number: order?.tracking_number,
            status: "Rejected",
          };
          return normalizeObj;
        }
      }
    );
  }

  const batchProcess = batchProcessOrders?.batch_processes?.find(
    (process) => process?._id === processId
  );

  if (processId) {
    const batchProcess = batchProcessOrders?.batch_processes?.find(
      (process) => process?._id === processId
    );
    activeOrders = batchProcess?.orders?.filter(
      (order) => order?.status?.toString() === "processing"
    );


    fulfilledOrders = batchProcess?.orders?.filter(
      (order) => order?.status === "Shipped"
    );
    // eslint-disable-next-line array-callback-return
    failedOrders = batchProcess?.orders?.filter((order) => {
      if (
        (!order?.status || order?.status !== "Shipped") &&
        order?.status !== "processing"
      ) {
        const normalizeObj = {
          ...order,
          tracking_number: order?.tracking_number,
          status: "Rejected",
        };
        return normalizeObj;
      }
    });
  }

  const manipulateFailedOrders = failedOrders?.map((item) => {
    return {
      ...item,
      status: "Rejected",
    };
  });

  return (
    <Box
      sx={{
        paddingBottom: "20px",
        width: "100%",
        marginTop: "30px",
        boxShadow:
          " 0px 2px 2px rgb(145 158 171 / 20%), 0px 12px 24px -4px rgb(145 158 171 / 12%)",
      }}
    >
      <Box>
        <Tabs
          value={value}
          sx={{
            position: "relative",
            zIndex: 1,
            "& .Mui-Selected": {
              color: "red",
            },
          }}
          onChange={handleChange}
          aria-label="basic tabs example"
          inkBarStyle={{ backgroundColor: "#000" }}
        >
          <Tab
            label={
              <div
                style={{
                  display: "flex",
                  fontWeight: value === 0 && "700",
                }}
              >
                {StoreTabColorDecisionMaker("Active", activeOrders?.length)}
                Active
              </div>
            }
            {...a11yProps(0)}
          />
          <Tab
            label={
              <div
                style={{
                  display: "flex",
                  fontWeight: value === 1 && "700",
                }}
              >
                {StoreTabColorDecisionMaker(
                  "Fulfilled",
                  fulfilledOrders?.length
                )}
                Fulfilled
              </div>
            }
            {...a11yProps(1)}
          />
          <Tab
            label={
              <div
                style={{
                  display: "flex",
                  fontWeight: value === 2 && "700",
                }}
              >
                {StoreTabColorDecisionMaker("Rejected", failedOrders?.length)}
                Rejected
              </div>
            }
            {...a11yProps(2)}
          />

          <>
            {batchProcess?.media && <div
              className="flexbox"
              style={{
                position: "absolute",
                right: 20,
                top: "50%",
                transform: "translate(0%, -50%)",
              }}
            >
              <a
                href={batchProcess?.media}
                download="Example-PDF-document"
                // target="_blank"
                rel="noreferrer"
              >
                <Download sx={{ cursor: "pointer" }} />
              </a>
            </div>}
          </>
        </Tabs>
      </Box>

      <TabPanel value={value} index={0}>
        <ProcesingOrdersDataTable orders={activeOrders} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <ProcesingOrdersDataTable orders={fulfilledOrders} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <ProcesingOrdersDataTable orders={manipulateFailedOrders} />
      </TabPanel>

      {/* <div
        style={{
          left: "45%",
          borderRadius: "8px",
          display: "flex",
          justifyContent: "end",
        }}
      >
        <Stack
          spacing={2}
          sx={{
            padding: "0 10px 0 0",
            borderRadius: "5px",
          }}
        >
          <AdminTablesPagination
            title="orders"
            // count={orderInfo?.totalOrders}
            storeId=""
          />
        </Stack>
      </div> */}
    </Box>
  );
}
